import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const page = css`
    padding: 0;
  `;

  const card = css`
    border-radius: 4px;
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};
    margin-bottom: 16px;
  `;

  const cardHeader = css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.navy["1"]};
    padding: 0px 16px;
  `;

  const headerRow = css`
    padding: 20px 0 0 20px;
    align-items: center;
  `;

  const title = css`
    font-family: "Open Sans", sans-serif;
    font-size: 24px;
    font-weight: 700;
    color: ${theme.colors.navy["1"]};
  `;

  const hr = css`
    margin-left: 30px;
    margin-right: 30px;
  `;

  const section = css`
    background: #fafafa;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 15px;
  `;

  const sectionHeader = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0px;
    cursor: pointer;
  `;

  const sectionTitle = css`
    font-weight: 700;
    font-size: 16px;
    color: ${theme.colors.navy["1"]};
  `;

  const sectionChevron = css`
    color: ${theme.colors.navy["1"]};
    font-size: 20px;
    cursor: pointer;
  `;

  const sectionBody = css`
    margin-top: 5px;
  `;

  const sectionTable = css`
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.15);

    .collapsedDetailRow > td {
      padding: 0 !important;
    }

    .collapsedDetailRow td > div[data-testid="dataTable"] {
      padding: 0 !important;
    }

    tbody tr:hover {
      background-color: inherit !important;
    }
  `;

  const detailTable = css`
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};

    td:first-child {
      padding-left: 60px;
    }

    tbody tr:hover {
      background-color: inherit !important;
    }
  `;

  const hideDetailHead = css`
    thead {
      display: none;
    }
  `;

  const columnWidths = css`
    table {
      table-layout: fixed;
      width: 100%;
    }
  `;

  const summaryColumnWidths = css`
    th:first-child,
    td:first-child {
      width: 12%;
    }

    th:nth-child(2),
    td:nth-child(2) {
      width: 70%;
    }

    th:nth-child(3),
    td:nth-child(3) {
      width: 18%;
    }
  `;

  const detailColumnWidths = css`
    th:first-child,
    td:first-child {
      width: 12%;
    }

    th:nth-child(2),
    td:nth-child(2) {
      width: 18%;
    }

    th:nth-child(3),
    td:nth-child(3) {
      width: 22%;
    }

    th:nth-child(4),
    td:nth-child(4) {
      width: 30%;
    }

    th:nth-child(5),
    td:nth-child(5) {
      width: 18%;
    }
  `;

  const stepHeader = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    font-weight: 600;
    font-size: 14px;
    color: ${theme.colors.navy["1"]};
  `;

  const versionLink = css`
    font-size: 13px;
    color: ${theme.colors.teal["1"]};
    cursor: pointer;
    font-weight: 400;

    &:hover {
      text-decoration: underline;
    }
  `;

  const addApproverBtn = css`
    font-size: 13px;
    color: ${theme.colors.teal["1"]};
    cursor: pointer;
    font-weight: 400;

    &:hover {
      text-decoration: underline;
    }
  `;

  const statusBadge = css`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 13px;
    font-weight: 600;
    text-transform: capitalize;
  `;

  const noData = css`
    padding: 16px;
    color: #6c757d;
  `;

  const gearIcon = css`
    cursor: pointer;
    font-size: 18px;
    color: ${theme.colors.navy["1"]};
  `;

  const cogMenu = css`
    position: absolute;
    top: 100%;
    right: 0;
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.gray["2"]};
    border-radius: 5px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    padding: 5px 10px;
    z-index: 1000;
    white-space: nowrap;
    min-width: 160px;
  `;

  const cogMenuItem = css`
    padding: 5px 15px;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    font-family: "Open Sans", sans-serif;

    &:hover {
      background-color: #f0f0f0;
    }
  `;

  return {
    page,
    card,
    cardHeader,
    headerRow,
    title,
    hr,
    section,
    sectionHeader,
    sectionTitle,
    sectionChevron,
    sectionBody,
    sectionTable,
    detailTable,
    hideDetailHead,
    columnWidths,
    summaryColumnWidths,
    detailColumnWidths,
    stepHeader,
    versionLink,
    addApproverBtn,
    statusBadge,
    noData,
    gearIcon,
    cogMenu,
    cogMenuItem,
  };
};

export default useStyles;
